import { narrowVariant, useComponentVariant } from "@ui-kit/hooks/useComponentVariant";
import { MenuItem } from "@ui-kit/MenuItem";
import { forwardRef, type HTMLAttributes, useCallback } from "react";
import { tv } from "tailwind-variants";

// Surface classes mirror the glass variant of DropdownMenuItem — MenuItem itself implements only `inverse`
const emojiPickerItemStyles = tv({
	base: "p-1 h-7 w-7 justify-center leading-none text-xl",
	variants: {
		variant: {
			glass: ["rounded-lg bg-transparent text-primary-fg", "hover:bg-secondary-border focus:bg-secondary-border"],
		},
	},
});

interface EmojiPickerItemProps extends Omit<HTMLAttributes<HTMLDivElement>, "onClick"> {
	emoji: string;
	onClick?: (emoji: string) => void;
}

export const EmojiPickerItem = forwardRef<HTMLDivElement, EmojiPickerItemProps>(
	({ emoji, className, onClick, ...props }, ref) => {
		const { variant } = useComponentVariant();

		const handleClick = useCallback(() => {
			onClick?.(emoji);
		}, [emoji, onClick]);

		return (
			<MenuItem
				{...props}
				className={emojiPickerItemStyles({ className, variant: narrowVariant(variant, ["glass"]) })}
				onClick={handleClick}
				ref={ref}
			>
				{emoji}
			</MenuItem>
		);
	},
);
